import React, { useState } from "react";
import { toast } from "sonner";
import { finApi, finErr } from "@/lib/financeApi";
import { btnGold, Chip, VENDOR_TYPE_CHIP, when } from "@/components/nds/windows/finance/parts";
import { VENDOR_FIELDS, VendorFields } from "@/components/nds/windows/finance/VendorsView";

export default function VendorProfileTab({ vendor, reload }) {
  const [edit, setEdit] = useState(null);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setEdit((x) => ({ ...x, [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value }));
  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { id, created_at, updated_at, engine_recommendation, ...body } = edit; // eslint-disable-line no-unused-vars
      await finApi.patch(`/vendors/${vendor.id}`, body);
      toast.success("Vendor updated");
      setEdit(null);
      reload();
    } catch (err) { toast.error(finErr(err)); } finally { setBusy(false); }
  };

  if (edit) return (
    <form onSubmit={save} data-testid="fin-vendor-edit-form" className="p-5 space-y-3">
      <VendorFields v={edit} set={set} prefix="fin-vendor-edit" />
      <div className="flex justify-end gap-2">
        <button type="button" onClick={() => setEdit(null)} data-testid="fin-vendor-edit-cancel" className="font-mono text-[10px] tracking-[0.2em] uppercase text-nex-muted">Cancel</button>
        <button type="submit" disabled={busy || !edit.name?.trim()} data-testid="fin-vendor-edit-save" className={btnGold}>Save</button>
      </div>
    </form>
  );
  const [tone, label] = VENDOR_TYPE_CHIP[vendor.type];
  return (
    <div data-testid="fin-vendor-profile-tab" className="p-5 space-y-4">
      <div className="flex items-center gap-2">
        <Chip tone={tone}>{label}</Chip>
        <Chip tone={vendor.active ? "green" : "grey"} data-testid="fin-vendor-profile-active">{vendor.active ? "Active" : "Inactive"}</Chip>
        <button type="button" onClick={() => setEdit({ ...vendor })} data-testid="fin-vendor-edit" className={`${btnGold} ml-auto`}>Edit</button>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
        {[...VENDOR_FIELDS, ["payment_method", "Payment method"], ["notes", "Notes"],
          ...(vendor.legacy_import ? [["pay_period_frequency", "Pay schedule"], ["pay_period_anchor", "Pay period anchor"]] : [])].map(([k, l]) => (
          <div key={k} className="space-y-0.5">
            <div className="font-mono text-[9px] tracking-[0.2em] uppercase text-nex-muted">{l}</div>
            <div data-testid={`fin-vendor-profile-${k}`} className="text-sm text-nex-silver break-words">{(k === "bank_last4" && vendor[k] ? `•••• ${vendor[k]}` : vendor[k]) || "—"}</div>
          </div>
        ))}
      </div>
      <p className="text-[11px] text-nex-muted">Added {when(vendor.created_at)} · updated {when(vendor.updated_at)}</p>
    </div>
  );
}
